export default "__VITE_ASSET__hhINOAiz__"